// Contexto, copy e ponto da bolinha de documento pendente (owner C1014323), à
// parte para o CompanyDocuments os usar sem import circular com PendenciaDocs.jsx.
import React, { createContext, useContext } from "react";

/** Copy aprovada do aviso de pendência (R10); re-exportada pelo CompanyDocuments. */
export const COPY_PENDENCIA = "Documentos obrigatórios pendentes:";

/** Rótulo acessível da bolinha: a copy aprovada do aviso, sem os «:» finais. */
export const ARIA_PENDENCIA = COPY_PENDENCIA.replace(/:\s*$/, "");

export const PendenciaDocsContext = createContext({ pendente: false, refresh: () => {} });

export function usePendenciaDocs() {
  return useContext(PendenciaDocsContext);
}

/** Ponto vermelho (molde do `notif-unread-dot` do Header). `className` posiciona. */
export function PendenciaDot({ testid, className = "" }) {
  const { pendente } = usePendenciaDocs();
  if (!pendente) return null;
  return (
    <span
      className={`h-2 w-2 rounded-full bg-red-600 ${className}`}
      role="status"
      aria-label={ARIA_PENDENCIA}
      title={ARIA_PENDENCIA}
      data-testid={testid}
    />
  );
}
